//@ts-nocheck
import React from 'react'
import Navbar from './Navbar'
import Footer from './Footer'
import About from './About'
import Pricing from "./Pricing"
import Services from './Services'
import Home from './Home'
import Contact from './Contact'



export default function Landing() {
  return (
    <>
    <Home/>
    <About/>
    <Pricing/>
    <Services/>
    </>
  )
}
